---
title: "First Parts Received for Mass Simulator"
date: 2025-11-29
category: "Engineering"
---

Following our [Manufacturing Readiness Review](/blog/dynamic-test-model-manufacturing-readiness-review-complete) earlier this month, we've received the first batch of parts for the mass simulator build.

![Parts array](/images/blog-first-parts/parts-array.png)

## Mock Mirrors

A key component of the mass simulator is the mock mirror set. These aren't optical-quality surfaces—they're mass and stiffness representatives designed to replicate the dynamic behavior of our flight mirrors during vibration testing.

![Mock mirror front](/images/blog-first-parts/mirror-front.png)

The mock mirrors match the mass distribution and mounting interfaces of the flight design, giving us accurate modal response without the cost and lead time of optical fabrication.

## Assembly Fixtures

We also received assembly fixturing and hardware needed to begin testing our integration and assembly processes.

![Clamp fixture](/images/blog-first-parts/clamp-mock.png)

## What's Next

With parts in hand, we begin assembly rehearsals. This is where we validate our integration procedures and train the team before moving to flight hardware.
